import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { KeywordsListComponent } from './keywords-list/keywords-list.component';
import { KeywordsCreateComponent } from './keywords-create/keywords-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: KeywordsListComponent,
        data: {
          title: "Keywords List",
          breadcrumb: "Keywords List"
        }
      },
      {
        path: 'create',
        component: KeywordsCreateComponent,
        data: {
          title: "Create Keywords",
          breadcrumb: "Create Keywords"
        }
      },
      {
        path: 'edit/:id',
        component: KeywordsCreateComponent,
        data: {
          title: "Edit Keywords",
          breadcrumb: "Edit Keywords"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class KeywordsRoutingModule { }
